import { isAnchorUrl } from '@core/shared/utils';
export var UrlType = /*#__PURE__*/function (UrlType) {
  UrlType["Absolute"] = "AbsoluteHttp";
  UrlType["Relative"] = "RelativeHttp";
  UrlType["Hash"] = "Hash";
  UrlType["CustomProtocol"] = "CustomProtocol";
  UrlType["Invalid"] = "Invalid";
  return UrlType;
}(UrlType || {});
/**
 * URL.parse is a strong feature, but it will always resolve to a full URL.
 * This is not what we intend to do, we want to find out what type of URL statement we got.
 * Due to this, we need to combine it with some more manual checks.
 */
export function analyzeUrl(url) {
  if (!url || !url.length) return {
    type: UrlType.Invalid
  };
  // normalize a special case: URL might be a "full" url with omitted protocol, e.g. //test.com.
  // URL.parse is not able to parse them, so we prepend http: protocol to allow parsing them correctly.
  if (url.startsWith('//')) {
    const protocol = 'http:';
    url = protocol + url;
  }
  // if URL.parse works out of the box, we can safely say we got a full URL.
  // however it is unclear if it is http or something like mailto: or a custom protocol.
  let urlObj = URL.parse(url);
  if (urlObj) {
    if (urlObj.protocol.startsWith('http')) {
      return {
        type: UrlType.Absolute,
        urlObj
      };
    } else {
      return {
        type: UrlType.CustomProtocol,
        urlObj
      };
    }
  }
  // URL.parse failed. So the url does not contain a full/valid url but likely a partial url or hash.
  if (isAnchorUrl(url)) return {
    type: UrlType.Hash
  };
  // all that is left is a relative URL.
  return {
    type: UrlType.Relative
  };
}